<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
  total: {
    type: Number,
    required: true
  },
  perPage: {
    type: Number,
    required: true
  },
  currentPage: {
    type: Number,
    required: true
  },
  itemLabel: {
    type: String,
    default: 'items'
  },
  totalVisible: {
    type: Number,
    default: 7
  },
  showRange: {
    type: Boolean,
    default: true
  },
  show: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['update:page'])

const totalPages = computed(() => {
  return Math.ceil(props.total / props.perPage) || 1
})

const startItem = computed(() => {
  if (!props.total) return 0

  return (props.currentPage - 1) * props.perPage + 1
})

const endItem = computed(() => {
  return Math.min(props.currentPage * props.perPage, props.total)
})
</script>
<template>
  <v-row
    v-if="show || totalPages > 1"
    no-gutters
    align="center"
    class="base-pagination mt-3"
  >
    <div v-if="showRange" class="text-caption grey--text text--darken-1">
      Showing {{ startItem }}-{{ endItem }} of {{ total }} {{ itemLabel }}
    </div>

    <v-spacer />

    <v-pagination
      :value="currentPage"
      :length="totalPages"
      :total-visible="totalVisible"
      :disabled="disabled"
      @input="$emit('update:page', $event)"
    />
  </v-row>
</template>
